import styled from "styled-components"

const Title = styled.h2`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const H1Title = styled.h1`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const Container = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  & a {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
    &::before {
      background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }
`
export { Title, H1Title, Container }
